import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToWords } from 'to-words';

@Component({
  selector: 'app-book-crdtnote-rcpt',
  templateUrl: './book-crdtnote-rcpt.component.html',
  styleUrls: ['./book-crdtnote-rcpt.component.scss'],
})
export class BookCrdtnoteRcptComponent implements OnInit {

  crdtNoteData: any;
  BookBillingData: any[] = [];
  bookcreditdata: any[] = [];
  selectedBooks: any[] = [];

  totalCreditAmount: number = 0;
  crdtnotetotal: number = 0;
  crdreturncopies = 0;

  toWords: any;
  crdtnotetotalwords: string = '';

  totalamount = 0;
  totalremainingamt = 0;
  crdtnoteamttotal = 0;
  remainingTotal = 0;
  previousTotal = 0;

  address = '';
  payloadArray: any[] = [];

  constructor(
    public service: DigisubservicesService,
    private dialogRef: MatDialogRef<BookCrdtnoteRcptComponent>,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('bookcrdtnote data', this.data);
  }

  ngOnInit(): void {
    debugger

    this.crdtNoteData = this.data['data'] || {};
    this.BookBillingData = this.data['BookBillingData'] || [];
    this.bookcreditdata = this.data['bookcreditdata'] || [];

    // ✅ Map each book and carry remark + credit_remark from UpdatedBillingData
    this.selectedBooks = this.BookBillingData.map(book => ({
      ...book,
      credit_remark: book.remarks || book.credit_remark || ''  // ✅ use per-book remark
    }));

    // Credit note total
    this.crdtnotetotal =
      Number(this.crdtNoteData?.credit_amount || this.crdtNoteData?.crditnoteamt) || 0;

    // Return copies
    this.crdreturncopies = Number(this.crdtNoteData?.returncopies) || 0;

    // Convert amount to words
    this.toWords = new ToWords();
    this.crdtnotetotalwords = this.toWords.convert(this.crdtnotetotal, {
      currency: true,
    });

    // Address
    const billing0 = this.BookBillingData[0] || {};
    this.address = `${billing0.address || ''} ${billing0.taluka || ''}, ${billing0.district || ''}, ${billing0.state || ''}, ${billing0.country || ''}.`;

    // Reset totals
    this.totalamount = 0;
    this.crdtnoteamttotal = 0;
    this.totalremainingamt = 0;
    this.remainingTotal = 0;
    this.previousTotal = 0;

    // Loop books
    this.selectedBooks.forEach((item: any) => {
      const invoiceTotal = Number(item.invoice_total) || 0;
      const prevRemaining = Number(item.total_remaining_amt) || 0;
      const creditAmt = Number(item.credit_amount) || 0;
      const newRemaining = prevRemaining - creditAmt;

      this.totalamount += invoiceTotal;
      this.crdtnoteamttotal += creditAmt;
      this.remainingTotal += newRemaining;
      this.totalremainingamt += prevRemaining;
      this.previousTotal += prevRemaining;

      item.previous_rem = prevRemaining;
      item.remaining_amt = newRemaining;
    });

    // ✅ Build payload — each book carries its own remark
    this.payloadArray = this.BookBillingData.map((billingItem: any, index: number) => {
      const creditAmt = Number(billingItem.credit_amount) || 0;
      const prevRemaining = Number(billingItem.total_remaining_amt) || 0;
      const newRemaining = prevRemaining - creditAmt;

      return {
        id: billingItem.id || null,
        crdtnote_no: this.crdtNoteData.crdtnoteno,

        date: this.crdtNoteData.date
          ? new Date(this.crdtNoteData.date).toLocaleDateString('en-CA')
          : '',

        todaydate: this.crdtNoteData.todaydate
          ? new Date(this.crdtNoteData.todaydate).toISOString().split('T')[0]
          : '',

        rep_name: billingItem.rep_name || '',
        office_rep_name: billingItem.office_rep_name || '',
        book_seller_name: this.crdtNoteData.bsname || '',

        crdtnote_total: creditAmt,
        bookcopies: billingItem.return_copies || 0,

        voc_date: billingItem.voucher_date || '',
        order_no: billingItem.order_no || '',
        invoice_no: billingItem.invoice_no || '',

        // ✅ Each book gets its own remark — not a global one
        credit_remark: billingItem.remark || billingItem.credit_remark || '',

        previous_rem: prevRemaining,
        remaining_amt: newRemaining,

        bill_no: this.bookcreditdata[index] || []
      };
    });

    console.log("Payload with per-book remarks:", this.payloadArray.map(p => ({
      invoice_no: p.invoice_no,
      credit_remark: p.credit_remark   // ✅ verify each book has correct remark
    })));

    this.cdr.detectChanges();
  }


  print() {
    window.print();
  }


 save() {
  console.log("Bill data:", this.crdtNoteData.bill_no);
  console.log("Payload data:", this.payloadArray);

  // ✅ Check credit amount
  const zeroAmountBooks = this.payloadArray.filter(item =>
    Number(item.crdtnote_total) === 0 || item.crdtnote_total == null
  );

  if (zeroAmountBooks.length > 0) {
    alert('Book price not saved. Please enter credit amount.');
    return;
  }

  const books = Array.isArray(this.crdtNoteData.bill_no) ? this.crdtNoteData.bill_no : [];

  // ✅ Match each payload item with its own book and assign remark individually
  this.payloadArray.forEach(item => {
    const matchedBook = books.find(b => String(b.invoice_no) === String(item.invoice_no));

    if (matchedBook) {
      // ✅ Assign remark per book — not global
      item.credit_remark = matchedBook.remark || matchedBook.credit_remark || '';

      // ✅ Assign copies only for this specific remark
      if (matchedBook.remark && matchedBook.remark.trim() === 'विक्री झाली नाही') {
        item.book_copies = matchedBook.book_copies;
      }
    }
  });

  console.log("Final payload remarks:", this.payloadArray.map(p => ({
    invoice_no: p.invoice_no,
    credit_remark: p.credit_remark  // ✅ verify each has correct remark
  })));

  this.service.updateBookCopies(this.payloadArray).subscribe(() => {
    this.insertCreditNotes();
  });
}

insertCreditNotes() {
  this.service.insertBookPymtCrdt(this.payloadArray).subscribe(() => {
    setTimeout(() => {
      alert('Credit Note Added Successfully.');
      location.reload();
      this.dialogRef.close();
    }, 1200);
  });
}


  convertToInt(val: any): number {
    return Number(val) || 0;
  }
}